<!-- Page Breadcrumbs Start -->
<div class="slider bg-navy-blue bg-fixed pos-rel breadcrumbs-page breadcrumbs-page-3">
  <div class="container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['../home']"><i class="icofont-home"></i></a></li>
        <li class="breadcrumb-item active" aria-current="page">QOR Rinse</li>
      </ol>
    </nav>
    <h1>QOR Rinse</h1>
    <div class="breadcrumbs-description">
      Full-service non-hazardous equipment cleaning — fast turnaround, clean certificates, and return transport.
    </div>
  </div>
</div>
<!-- Page Breadcrumbs End -->

<!-- Main Body Content Start -->
<main id="body-content">

  <!-- Overview Start -->
  <section class="wide-tb-80">
    <div class="container pos-rel">
      <div class="row align-items-start">

        <!-- Main Content -->
        <div class="col-md-12 col-lg-8">

          <!-- Intro -->
          <div class="mb-5">
            <h4 class="h4-md mb-3 txt-blue fw-7">Industrial Equipment Cleaning You Can Count On</h4>
            <p>
              QOR Rinse specializes in full-service non-hazardous cleaning for a wide variety of industrial equipment.
              Our experienced crews are equipped to service the full range of boxes, tanks, and specialty containers
              found across chemical plants, oil refineries, tank terminals, marine shipyards, and construction sites —
              delivering consistent, thorough results on every job.
            </p>
            <p>
              We pride ourselves on quick turnaround times without sacrificing quality. Upon completion of each cleaning,
              QOR Rinse issues clean certificates that enable customers to efficiently return their equipment to the field.
              We also offer return transport directly to your yard or job site, keeping your fleet operational and your
              project timeline on track.
            </p>
          </div>

          <!-- Wash Services List -->
          <div class="mb-5">
            <h3 class="h3-md fw-7 mb-4 txt-blue">Wash Services</h3>
            <p class="mb-4">
              QOR Rinse cleans the full spectrum of non-hazardous waste equipment from our rental fleet and yours.
              Every unit is cleaned to standard and issued a certificate upon completion.
            </p>
            <ul class="list-unstyled icons-listing theme-orange mb-0">
              <div class="row resp-div">
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  25 Yard Vacuum Boxes
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  20 &amp; 25 Yard Roll Tarp Boxes
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  Dewatering Boxes
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  20, 25, 30 &amp; 40 Yard Open Top Boxes
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  25 Yard Metal Lid Boxes
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  500bbl Frac Tanks
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  200bbl Mini Frac Tanks
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  Poly Tanks
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  Containment Berms
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  70bbl Vacuum Trucks
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  130bbl Vacuum Trailers
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  Chemical Hoses
                </li>
                <li class="col-lg-6 col-md-6 col-sm-12">
                  <i class="icofont-double-right"></i>
                  Tank Fittings
                </li>
              </div>
            </ul>
          </div>

          <!-- Additional Capabilities -->
          <div class="mb-2">
            <h3 class="h3-md fw-7 mb-4 txt-blue">Additional Capabilities</h3>
            <div class="row">
              <div class="col-md-4 mb-4">
                <div class="rinse-capability-card">
                  <i class="icofont-water-drop rinse-capability-icon"></i>
                  <h5 class="fw-7 mb-2">Live Wash</h5>
                  <p class="mb-0">On-demand cleaning available while your operation stays in motion — minimizing downtime.</p>
                </div>
              </div>
              <div class="col-md-4 mb-4">
                <div class="rinse-capability-card">
                  <i class="icofont-bin rinse-capability-icon"></i>
                  <h5 class="fw-7 mb-2">Material Dig Out &amp; Heel Disposal</h5>
                  <p class="mb-0">Hardened or accumulated material removed and properly disposed of before cleaning begins.</p>
                </div>
              </div>
              <div class="col-md-4 mb-4">
                <div class="rinse-capability-card">
                  <i class="icofont-truck-alt rinse-capability-icon"></i>
                  <h5 class="fw-7 mb-2">Box &amp; Tank Return</h5>
                  <p class="mb-0">Equipment returned directly to your yard or job site after cleaning — one less handoff to manage.</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Schedule a Cleaning — desktop only (sits in blank space below capability cards) -->
          <div class="d-none d-lg-block mt-2">
            <div class="widget-wrap">
              <h3 class="h3-md fw-7 mb-3">Schedule a Cleaning</h3>
              <p>Ready to get your equipment cleaned and back in the field? Contact our team to schedule service.</p>
              <a class="btn btn-theme bg-orange" [routerLink]="['../contact-us']">
                Get In Touch <i class="icofont-rounded-right"></i>
              </a>
            </div>
          </div>

        </div>
        <!-- End Main Content -->

        <!-- Sidebar -->
        <div class="col-md-12 col-lg-4">
          <aside class="sidebar-spacer row">

            <!-- Why QOR Rinse -->
            <div class="sidebar-primary col-lg-12 col-md-6">
              <div class="widget-wrap">
                <h3 class="h3-md fw-7 mb-4">Why QOR Rinse?</h3>
                <ul class="list-unstyled icons-listing theme-orange mb-4">
                  <li><i class="icofont-check-circled"></i> Quick turnaround on all equipment</li>
                  <li><i class="icofont-check-circled"></i> Clean certificates issued on completion</li>
                  <li><i class="icofont-check-circled"></i> Return transport to yard or job site</li>
                  <li><i class="icofont-check-circled"></i> Live wash capability</li>
                  <li><i class="icofont-check-circled"></i> Dig out &amp; heel disposal on-site</li>
                  <li><i class="icofont-check-circled"></i> Non-hazardous compliant cleaning</li>
                  <li><i class="icofont-check-circled"></i> Experienced, safety-first crews</li>
                </ul>
              </div>
            </div>

            <!-- Image 1 -->
            <div class="widget-wrap col-lg-12 col-md-6">
              <img src="assets/images/qor/frac-cleaning.jpg" alt="Frac tank cleaning" class="rounded mb-4 img-resp">
            </div>

            <!-- Image 2 -->
            <div class="widget-wrap col-lg-12 col-md-6">
              <img src="assets/images/qor/combo-unit.jpg" alt="QOR combo unit" class="rounded mb-4 img-resp">
            </div>

            <!-- CTA — shown only below lg (desktop shows it inline under capability cards) -->
            <div class="sidebar-primary col-lg-12 col-md-6 d-lg-none">
              <div class="widget-wrap">
                <h3 class="h3-md fw-7 mb-3">Schedule a Cleaning</h3>
                <p>Ready to get your equipment cleaned and back in the field? Contact our team to schedule service.</p>
                <a class="btn btn-theme bg-orange" [routerLink]="['../contact-us']">
                  Get In Touch <i class="icofont-rounded-right"></i>
                </a>
              </div>
            </div>

          </aside>
        </div>
        <!-- End Sidebar -->

      </div>
    </div>
  </section>
  <!-- Overview End -->

  <!-- Callout Start -->
  <section class="wide-tb-80 bg-scroll bg-img-6 pos-rel callout-style-1">
    <div class="bg-overlay blue opacity-60"></div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-4 col-md-12 mb-0">
          <h4 class="h4-xl">Interested in working with QOR Companies?</h4>
        </div>
        <div class="col"></div>
        <div class="col-sm-auto">
          <a href="#" class="btn btn-theme bg-white bordered" [routerLink]="['../contact-us']">
            Get In Touch
            <i class="icofont-rounded-right"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
  <!-- Callout End -->

</main>
